import { useEffect, useRef, useState } from 'react'

import { getFileById } from '../../../../api'
import { useOutboundUuid } from '../../../../hooks'

export function useLoadFileById(getFile) {
  const [file, setFile] = useState(null)
  const [loading, setLoading] = useState(false)

  const timerRef = useRef(null)

  const outboundUuid = useOutboundUuid()

  async function getFileByIdDefault(id, params) {
    return getFileById({ id, outboundUuid, params })
  }

  const loadFileById = getFile ?? getFileByIdDefault

  useEffect(() => {
    return () => {
      clearTimeout(timerRef.current)
    }
  }, [])

  async function getFileData({ apiParams, id }) {
    setLoading(true)

    return loadFileById(id, apiParams).then(({ data }) => {
      if (data?.checking || data.message) {
        timerRef.current = setTimeout(
          () => getFileData({ apiParams, id }),
          1000
        )
      } else {
        setFile(data)

        setLoading(false)
      }

      return data
    })
  }

  return {
    file,
    getFileData,
    loading,
    setFile,
  }
}
